export const extractBingoRoomId = (code: string | undefined | null): string => {
  if (!code) {
    return ''
  }

  return String(code).replace(/\D/g, '') || String(code)
}

export const parseJackpotSafe = (val: string | undefined | null): number | undefined => {
  if (val == null || val === '') {
    return undefined
  }
  const n = parseFloat(val)

  return Number.isNaN(n) ? undefined : n
}

export const getMinContribute = (amount: number) => {
  // minimum contribution is 0.5% of the current amount
  // if (current amount - 0.5) < 50 then minimum contribution is 50
  const minPercentageOfAmount = (amount * 0.5) / 100

  return Math.trunc(minPercentageOfAmount < 50 ? 50 : minPercentageOfAmount)
}

export const getMaxContribute = (amount: number) => {
  // maximum contribution is 10% of the current amount
  // if (current amount - 10%) < 50 then maximum contribution is 50
  const maxPercentageOfAmount = (amount * 10) / 100

  return Math.trunc(maxPercentageOfAmount < 50 ? 50 : maxPercentageOfAmount)
}
